import { maxLength, required } from "@/locale/locale.config";
import { helpers, maxValue } from "@vuelidate/validators";

function validator(form: any) {
  return {
    score: {
      required,
      maxValue: helpers.withMessage(
        `A pontuação máxima é ${form?.activity?.scoreRange}`,
        maxValue(form?.activity?.scoreRange)
      ),
    },
    feedback: {
      required,
      maxLength: maxLength(1000),
    },
  };
}
export { validator };
